import axios from 'axios'

require('es6-promise').polyfill()

export function Http (options) {
  const isFunction = object => {
    return !!(object && object.constructor && object.call && object.apply)
  }

  const getMutatorOrNull = mutator => {
    return (mutator && isFunction(mutator) ? mutator : null)
  }

  const isApiUrlNotEmptyAndString = options.apiUrl && typeof options.apiUrl === 'string'
  const apiUrl = isApiUrlNotEmptyAndString ? options.apiUrl : '/'
  const instance = axios.create({
    baseURL: apiUrl
  })

  if (options.beforeMutators) {
    const beforeMutatorSuccess = getMutatorOrNull(options.beforeMutators.success)
    const beforeMutatorError = getMutatorOrNull(options.beforeMutators.error)
    instance.interceptors.request.use(beforeMutatorSuccess, beforeMutatorError)
  }

  if (options.afterMutators) {
    const afterMutatorSuccess = getMutatorOrNull(options.afterMutators.success)
    const afterMutatorError = getMutatorOrNull(options.afterMutators.error)
    instance.interceptors.response.use(afterMutatorSuccess, afterMutatorError)
  }

  return instance
}

export const All = axios.all

export const Spread = axios.spread

export const CancelToken = axios.CancelToken



// WEBPACK FOOTER //
// ./src/common/http/base.js